<template>
  <div class="cl-inner">
    <a-form :form='form'>
      <a-form-item label="每节课时长/分钟" :labelCol="{lg: {span: 3}}" :wrapperCol="{lg: {span: 5}}">
        <a-input-number
          :min="1"
          :max="100"
          style="width: 100%"
          :precision="0"
          v-decorator="[
            'duration',
            {rules: [{ required: true, pattern: /^\d{1,1000}$/, message: '请输入正整数' }], validateTrigger: 'change'}
          ]"
        />
      </a-form-item>

      <a-form-item label="前几天自动开班/天" :labelCol="{lg: {span: 3}}" :wrapperCol="{lg: {span: 5}}">
        <a-input-number
          :min="1"
          :max="100"
          style="width: 100%"
          :precision="0"
          v-decorator="[
            'open_class_days',
            {rules: [{ required: true, pattern: /^\d{1,1000}$/, message: '请输入正整数' }], validateTrigger: 'change'}
          ]"
        />
      </a-form-item>

      <a-form-item :wrapper-col="{offset: 3 }">
        <a-button type="primary" @click="updateBureauSetting()">更新</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import bureau from "../../api/bureau";

export default {
  name: 'bureauSetting',
  data(){
    return{
      form: this.$form.createForm(this),
    }
  },
  methods:{
    //获取教育局设置
    getBureauSetting(){
      bureau.getBureauSetting().then(res=>{
        let formData = {};
        formData.duration = this.getValue(res.data,'duration');
        formData.open_class_days = this.getValue(res.data,'open_class_days');
        setTimeout(() => {
          this.form.setFieldsValue(formData);
        }, 100);
      })
    },

    getValue(list,key){
      let res = '';
      list.map(item=>{
        if(item.settingKey == key){
          res = item.settingValue;
        }
      })
      return res;
    },

    //跟新教育局设置
    updateBureauSetting(){
      this.form.validateFields((err, value) => {
        console.log("输入的内容是：", value);
        if (!err) {
          let req = [];
          for(let key in value){
            if(value[key]){
              req.push({
                settingKey: key,
                settingValue: value[key],
              })
            }
          }
          console.log(req)
          bureau.updateBureauSetting({bureauSettingFormJson:JSON.stringify(req)}).then(res=>{
            console.log(res)
            this.$message.success('更新成功');
          })
        }
      })
    },
  },
  created(){
    this.$store.dispatch('getUserInfo').then(res=>{
      this.getBureauSetting();
    })
  }

}
</script>
<style lang="scss" scoped>
  @import "src/config/var";
  .cl-inner {
    width: calc(100% - 40px);
    padding: 20px;
    background: white;
    margin: 20px auto;
  }
</style>